import { parameterAffectPanelPrice, calculatePanel } from 'pu-data/Utils'

export const customerRedux = (state, name, value) => {
  switch (name) {
    case 'finish_plating':
      finishPlatingParameter(state, name, value);
      break;
    case 'add_rails_left_right':
    case 'add_rails_top_bottom':
      railsParameters(state, name, value);
      break;
    case 'tab_route_panels':
      tabRoutePanelsParameter(state, name, value);
      break;
    case 'v_score_panels':
      vScorePanelsParameter(state, name, value);
      break;
    case 'number_of_counterbore_holes':
      numCounteboreHoles(state, name, value);
      break;
    case 'number_of_countersink_holes':
      numCountersinkHoles(state, name, value);
      break;
    case 'material_type_finish_plating':
      materialTypeFinishPlatingParameter(state, name, value);
      break;
    case 'qty1':
      state.quantities[0] = value
      break;
    case 'qty2':
      state.quantities[1] = value
      break;
    case 'qty3':
      state.quantities[2] = value
      break;
    case 'qty4':
      state.quantities[3] = value
      break;
    case 'array_spacing_x_tab_rout':
    case 'array_spacing_x_vscore':
      state.array_spacing_x = value
      state[name] = value
      break;
    case 'array_spacing_y_tab_rout':
    case 'array_spacing_y_vscore':
      state.array_spacing_y = value
      state[name] = value
      break;
    default:
      state[name] = value
      break
  }

  calculateRailWidths(state)
  if (mustUpdatePanelSize(state, name)) {
    updatePanelSize(state);
  }
};

const finishPlatingParameter = (state, name, value) => {
  const current = state.finish_plating;
  if (current !== 'Lead Free Solder' && current !== 'ENIG' && current !== 'Immersion Silver') {
    if (value === 'Lead Free Solder' || value === 'ENIG' || value === 'Immersion Silver') {
      if (state.material_type !== 'FR4TG180') {
        state.material_type = 'FR4TG180';
        //vfShowModalInformation('Since you selected a RoHS finish we automatically upgraded the material to FR4 Tg180. We recommend using FR4 Tg180 with RoHS finish.<br><br>You can change the Material back to FR4 Tg135 if you wish.', '#modal-form-messages');
      }
    }
  }
  state[name] = value
};

// add top/bottom or left/right rails
const railsParameters = (state, name, value) => {
  if (name === 'add_rails_left_right') {
    if (value === '1') {
      state.rails_left = '0.5'
      state.rails_right = '0.5'
    } else {
      state.rails_left = ''
      state.rails_right = '';
    }
  } else if (name === 'add_rails_top_bottom') {
    if (value === '1') {
      state.rails_top = '0.5'
      state.rails_bottom = '0.5'
    } else {
      state.rails_top = ''
      state.rails_bottom = '';
    }
  }
};

// eslint-disable-next-line no-unused-vars
export const tabRoutePanelsParameter = (state, name, value) => {
  Object.assign(state, {
    has_array: '1',
    scoring: '0',
    tab_rout: '1',
    array_spacing_x: state.array_spacing_x_tab_rout,
    array_spacing_y: state.array_spacing_y_tab_rout,
  })

}

// eslint-disable-next-line no-unused-vars
const vScorePanelsParameter = (state, name, value) => {
  Object.assign(state, {
    has_array: '1',
    scoring: '1',
    tab_rout: '0',
    array_spacing_x: state.array_spacing_x_vscore,
    array_spacing_y: state.array_spacing_y_vscore,
  })
}

const railsAllSide = ['rails_left', 'rails_right', 'rails_top', 'rails_bottom']

// calculate panel length without rails
const panelLengthNoRails = (state) => {
  const boardLength = parseFloat(state.board_length)
  const quanityX = parseFloat(state.array_x_qty)
  const spacingX = parseFloat(state.array_spacing_x) || 0.0

  if (isNaN(spacingX) || isNaN(quanityX) || isNaN(boardLength)) return null;

  return (boardLength * quanityX) + ((quanityX - 1) * spacingX)
}

// calculate panel width without rails
const panelWidthNoRails = (state) => {
  const boardWidth = parseFloat(state.board_width)
  const quanityY = parseFloat(state.array_y_qty)
  const spacingY = parseFloat(state.array_spacing_y) || 0.0

  if (isNaN(boardWidth) || isNaN(spacingY) || isNaN(quanityY)) return null;

  return (boardWidth * quanityY) + ((quanityY - 1) * spacingY)
}

const arrayLongSides = (state) => {
  const length = panelLengthNoRails(state)
  const width = panelWidthNoRails(state)

  if (length !== null && width != null) {
    if (length > width) {
      return ['rails_left', 'rails_right'];
    }
    return ['rails_top', 'rails_bottom'];
  }
  return null;
}

const arrayShortSides = (state) => {
  const length = panelLengthNoRails(state)
  const width = panelWidthNoRails(state)

  if (length !== null && width != null) {
    if (length > width) {
      return ['rails_top', 'rails_bottom'];
    }
    return ['rails_left', 'rails_right'];
  }
  return null;
}

const calculateRailWidths = (state) => {
  const sides = state.rails_sides
  const width = state.rail_width || ''

  _.each(railsAllSide, (side) => {
    state[side] = ''
  })

  if (sides === 'two_long_sides' && width !== '') {
    const longSides = arrayLongSides(state);
    if (longSides !== null) {
      _.forEach(longSides, (side) => {
        state[side] = width
      });
    }
  } else if (sides === 'two_short_sides' && width !== '') {
    const shortSides = arrayShortSides(state);
    if (shortSides !== null) {
      _.forEach(shortSides, (side) => {
        state[side] = width
      })
    }
  } else if (sides === 'all_four_sides' && width !== '') {
    _.forEach(railsAllSide, (side) => {
      state[side] = width
    });
  }
}

const numCounteboreHoles = (state, name, value) => {
  // whx calculate counterbores only accept 1 or 0
  if (name === 'number_of_counterbore_holes') {
    state.counterbores = parseInt(value, 10) > 0 ? '1' : '0';
  }
  state[name] = value
};

const numCountersinkHoles = (state, name, value) => {
  // whx calculate countersinks only accept 1 or 0
  state.countersinks = parseInt(value, 10) > 0 ? '1' : '0'
  state[name] = value
};

const materialTypeFinishPlatingParameter = (state, name, value) => {
  const values = _.split(value, '/')
  Object.assign(state, {
    material_type: values[0],
    finish_plating: values[1],
  })
  state[name] = value
}

const mustUpdatePanelSize = (state, name) => {
  const alsoCalculatePanel = [
    'tab_route_panels',
    'v_score_panels',
    'tab_rout',
    'scoring',
    'add_rails_top_bottom',
    'add_rails_left_right',
    'rails_sides',
    'rail_width',
    'array_spacing_x_tab_rout',
    'array_spacing_x_vscore',
    'array_spacing_y_tab_rout',
    'array_spacing_y_vscore',
  ];
  return (
    (parameterAffectPanelPrice(name) || alsoCalculatePanel.indexOf(name) >= 0)
    &&
    state.is_panelized === '0'
  );
};

export const basicParams = {
  material_type: 'FR4TG180',
  // finish_plating  : 'ENIG',
  copper_inners: '1 oz',
  copper_outers: '1 oz',
  solder_color: 'green',
  solder_sides: 'Both Sides',
  silkscreen_color: 'White',
  material_thickness: '0.062',
};

/**
 * check if a Map of parameters include same options of basicParams
 */
export const areSameBasicParams = (params) => {
  // const different = basicParams.findEntry((value, key) => value != params.get(key));
  // return different === undefined;

  const different = Object.keys(basicParams).find(key => basicParams[key] != params[key])
  // console.error('Fix')
  // return false;
  return different === undefined
}

const updatePanelSize = (state) => {
  const result = calculatePanel(state);
  if (result) {
    return Object.assign(state, {
      array_up: result.array_up,
      array_x: result.array_x,
      array_y: result.array_y
    })
  }
};

export const bestPriceRedux = (state, params) => {
  const defaultParams = Object.assign({}, basicParams, { finish_plating: 'ENIG' })
  if (params.finish_plating === 'ENIG') {
    if (areSameBasicParams(params)) {
      Object.assign(state, params, defaultParams, {
        material_type: 'FR4',
        finish_plating: 'Leaded Solder',
      })
    }
  }
  Object.assign(state, params, defaultParams)
}

export const offshoreRedux = (state, params) => {
  return Object.assign(state, params)
}
